import React, { useState, FC } from 'react';
import { CircularProgress, useTheme } from '@mui/material';
import { paths, replaceParams } from 'routing';
import { ListPage, PageId } from 'pages/common/ListPage';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment, { Moment } from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useGetCampaigns } from 'apollo/queries/getCampaigns.newsletter.graphql';
import {
  CampaignOrderByInput,
  NewsletterOrderByInput,
} from '__generated__/queries-newsletter';
import { buildEvents, getDaysInTheCalendarMonth } from './utils';
import { useGetNewsletters } from 'apollo/queries/getNewsletters.newsletter.graphql';
import { useStyles, eventStyles } from './styles';
import { FilterDrawer } from '../../components/FilterDrawer';
import { useHistory } from 'react-router-dom';
import { useGlobalNewslettersFilter } from 'utils/globalState';

export const CalendarPage: FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [newslettersFilter] = useGlobalNewslettersFilter();
  const [viewedDate, setViewedDate] = useState<Moment>(moment());
  const { data: campaignData, loading: campaignLoading } = useGetCampaigns({
    where: {
      newsletter: {
        id_in: newslettersFilter,
      },
      availableAt_in: getDaysInTheCalendarMonth(viewedDate).map((value) =>
        value.format('YYYY-MM-DD'),
      ),
    },
    first: 1000,
    skip: 0,
    orderBy: [CampaignOrderByInput.availableAt_DESC],
  });
  const {
    data: newsletterData,
    loading: newsletterLoading,
  } = useGetNewsletters({
    where: { id_in: newslettersFilter },
    first: 1000,
    skip: 0,
    orderBy: [NewsletterOrderByInput.available_DESC],
  });

  return (
    <ListPage filterDrawer={<FilterDrawer />} type={PageId.CALENDAR}>
      <div className={classes.calendarWrapper}>
        {(campaignLoading || newsletterLoading) && (
          <div className={classes.loader}>
            <CircularProgress size={100} />
          </div>
        )}
        <Calendar
          onNavigate={(selectedDate) => {
            setViewedDate(moment(selectedDate));
          }}
          events={buildEvents(viewedDate, campaignData, newsletterData)}
          showMultiDayTimes
          defaultDate={new Date()}
          views={['month', 'week', 'day']}
          tooltipAccessor={(event) => event.resource.tooltip || ''}
          localizer={momentLocalizer(moment)}
          eventPropGetter={(event) => eventStyles(event, theme)}
          onSelectEvent={(event) => {
            if (event.resource.type === 'campaign') {
              history.push(
                replaceParams(paths.CAMPAIGN_EDIT, {
                  id: event.id,
                }),
              );
            } else {
              history.push(
                `${paths.CAMPAIGN_NEW}?brand=${event.resource.brandKey}&name=${event.title}&availableAt=${event.start}`,
              );
            }
          }}
        />
      </div>
    </ListPage>
  );
};
